import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { ValidationErrorMessagesPipe } from '../../pipes/validation-error-messages.pipe';
import { ErrorDisplayComponent } from '../../../error/components/error-display/error-display.component';

@Component({
  selector: 'app-form-control-errors',
  imports: [ErrorDisplayComponent, ValidationErrorMessagesPipe],
  templateUrl: './form-control-errors.component.html',
  styleUrls: ['./form-control-errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormControlErrorsComponent {
  public readonly errors = input.required<ValidationErrors>();
}
